import { IDemo } from 'types'
import {
  mecExplainer,
  jigspace,
  mecAndSmartVenues,
  shotTracker,
  aerialApplications,
  blueforce,
  taqtile,
  vuzix
} from './demos/'

import { fullShow, keynote, panelDiscussion } from './eventReplay'

export const Demos: IDemo[] = [
  mecExplainer,
  blueforce,
  shotTracker,
  aerialApplications,
  mecAndSmartVenues,
  jigspace,
  vuzix,
  taqtile
]

export const EventReplays: IDemo[] = [fullShow, keynote, panelDiscussion]
